import type { Board } from "../board";
import { ShockBlast } from "../effects/shockBlast";
import { PRIORITY_LAST, type ProcessableThing } from "../interfaces";
import { DestroyableObstacle } from "../destroyableObstacle";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class Barrier extends DestroyableObstacle implements ProcessableThing {
	static key = "Barrier";
	private timeToLive: number;

	constructor(xy: XY, timeToLive: number = 20) {
		super(xy);
		this.timeToLive = timeToLive;
	}

	processTurn(board: Board): void {
		this.timeToLive--;
		if (this.timeToLive <= 0) {
			this.board!.addEffect(new ShockBlast(this.xy));
			board.removeAtEndOfTurn(this);
		}
	}

	getProcessPriority(): number {
		return PRIORITY_LAST;
	}

	serialize(): Record<string, unknown> {
		return { ...super.serialize(), timeToLive: this.timeToLive };
	}

	static deserialize(data: any): Barrier {
		const b = new Barrier(deserializeXY(data.xy), data.timeToLive);
		b.restoreBaseFields(data);
		return b;
	}
}
